import React from 'react';
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import fr from 'date-fns/locale/fr-CA';

const DateFilters = (props) => {
    const { t, i18n } = useTranslation();

    const {
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        enableCurrentPeriod,
        displayCurrentPeriod,
        component,
        dateFilterType,
        changeDateFilterType,
        labelFilterAll
    } = props;


    /*
    let startDateSelected = new Date();
    startDateSelected.setMonth(startDateSelected.getMonth() - 6); // Get 6 months before current date
    let endDateSelected = new Date(); // end date is current date

    if(manualDate){
        startDateSelected = Date.parse(startDate);
        endDateSelected = Date.parse(endDate);
    } */
    function convertUTCToLocalDate(date) {
        if (displayCurrentPeriod === true) {
            return null;
        }
        if (!date) {
            return date
        }
        date = new Date(date)
        date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
        return date
    }

    function convertLocalToUTCDate(date) {
        if (!date) {
            return date
        }
        date = new Date(date)
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
        return date
    }

    const btnClass = "btn btn--filter";

    const specificDate = (
        <div className="datespicker flex flex-column flex-md-row flex-md-wrap align-items-stretch flex-grow-1">
                <span className="align-self-start align-self-md-center justify-self-center">
                    <strong>{t("docs.invoices.table.filter.by_date")}&nbsp;</strong>
                </span>
        <div className="flex flex-row justify-content-between justify-content-md-start form-row mr-md-2">
            <label htmlFor="from" className="align-self-center justify-self-center mr-2 mb-0">
                {t("docs.invoices.table.filter.from")}
            </label>
            <div className="d-flex flex-sm-grow-1  align-self-center justify-self-center" style={{ maxHeight: "38px" ,position: "relative"}}>
                <DatePicker
                    autoComplete="off"
                    id="from" locale={(() => { if(i18n.language === "fr") { return (fr) }})()}
                    onChange={(date) => setStartDate(convertLocalToUTCDate(date), component)}
                    selected={convertUTCToLocalDate(startDate)}
                    className="form-control"
                />
                <i className="far fa-calendar-alt"  style={{ position: "absolute", right: "14px",  top: "12px", pointerEvents: "none" }}></i>
            </div>
        </div>
        <div className="flex flex-row justify-content-between justify-content-md-start form-row">
            <label htmlFor="to" className="align-self-center justify-self-center mr-2 mb-0">
                {t("docs.invoices.table.filter.to")}
            </label>
            <div className="d-flex flex-sm-grow-1 align-self-center justify-self-center" style={{ maxHeight: "38px" ,position: "relative"}}>
                <DatePicker
                    autoComplete="off"
                    id="to" locale={(() => { if(i18n.language === "fr") { return (fr) }})()}
                    onChange={(date) => setEndDate(convertLocalToUTCDate(date), props.component)}
                    selected={convertUTCToLocalDate(endDate)}
                    className="form-control"
                />
                <i className="far fa-calendar-alt" style={{position: "absolute", right: "14px",  top: "12px", pointerEvents: "none"}}></i>
            </div>
        </div>
    </div>
    )
    return (
        <div className="flex flex-column flex-md-row flex-wrap align-items-md-center justify-content-md-between flex-grow-1 pr-3">
            <div className="filter-scroll">
            <div className="filter-buttons flex flex--align-stretch flex--justify-start">
                {(enableCurrentPeriod?
                    <button onClick={() => { changeDateFilterType('current_period', component); }}
                            className={(dateFilterType === 'current_period') ? btnClass + ' btn--filter--active' : btnClass }>
                        {t("docs.invoices.table.filter.currentperiod")}
                    </button>
                    :null
                )}
                {(props.enableCurrentOrders?
                        <button onClick={() => { changeDateFilterType('current_orders', component); }}
                                className={(dateFilterType === 'current_orders') ? btnClass + ' btn--filter--active' : btnClass }>
                            { t("docs.invoices.table.filter.currentorders")}
                        </button>
                        :null
                )}

                {(!enableCurrentPeriod && labelFilterAll) &&
                    <button onClick={() => { changeDateFilterType('last_all', component); }}
                            className={(dateFilterType === 'last_all') ? btnClass + ' btn--filter--active' : btnClass }>
                        {labelFilterAll}
                    </button>
                }
                <button onClick={() => { changeDateFilterType('last_14', component); }}
                        className={(dateFilterType === 'last_14') ? btnClass + ' btn--filter--active' : btnClass }>
                    {t("docs.invoices.table.filter.last_14")}
                </button>
                <button onClick={() => { changeDateFilterType('last_30', component); }}
                        className={(dateFilterType === 'last_30') ? btnClass + ' btn--filter--active' : btnClass }>
                    {t("docs.invoices.table.filter.last_30")}
                </button>
                <button onClick={() => { changeDateFilterType('specific_date', component); }}
                        className={(dateFilterType === 'specific_date') ? btnClass + ' btn--filter--active' : btnClass }>
                    {t("docs.invoices.table.filter.specific_date")}
                </button>
            </div>
            </div>
            {dateFilterType === 'specific_date'?specificDate:''}
        </div>
    );
};

export default DateFilters;

export const DEFAULT_DATE = '1900-01-01T00:00:00';
export const TODAY = new Date();
export const TODAY_MINUS_14 = new Date().setDate(TODAY.getDate()-14);
export const TODAY_MINUS_30 = new Date().setDate(TODAY.getDate()-30);
export const DEFAULT_FILTER_ALL_PAGE_NUMBER = 1;
export const DEFAULT_FILTER_ALL_PAGE_SIZE = 50;
